import { create } from 'zustand';

const useUserStore = create((set) => ({
  user: {
    idpersona: '',
    email: '',
  },
  setUser: (user) => set({ user })
}))

/*
User: {
  id_usuario: {
    type: DataTypes.INTEGER,
    primaryKey: true
  },
  idpersona: {
    type: DataTypes.INTEGER,
  },
  email: {
    type: DataTypes.STRING,
    allowNull: false,
  },
}
*/

export default useUserStore;